import { ENumberInputSizeVariant, NumberInput } from '@outdoorsyco/bonfire';
import React from 'react';

import Text from '@/components/switchback/Text/Text';

interface IGuestDetailItemProps {
  label: string;
  disclaimer: string;
  guestsCount: number;
  minQuantity?: number;
  maxQuantity?: number;
  onChange: (value: number) => void;
}

const GuestDetailItem: React.FC<IGuestDetailItemProps> = ({
  label,
  disclaimer,
  guestsCount,
  minQuantity = 0,
  maxQuantity = 10,
  onChange,
}) => {
  return (
    <div className="flex justify-between">
      <div>
        <label className="text-base text-primary-base semiHighlight">{label}</label>
        <Text type="paragraph" className="text-sm text-secondary-base semiHighlight">
          {disclaimer}
        </Text>
      </div>
      <NumberInput
        ariaLabel={`${label}. ${disclaimer}`}
        maxValue={maxQuantity}
        minValue={minQuantity}
        value={guestsCount}
        size={ENumberInputSizeVariant.Small}
        onChange={onChange}
      />
    </div>
  );
};

export default GuestDetailItem;
